import React, { useEffect, useRef, useState } from 'react'

function LayeredDashboardModal({ children, isActive }) {
    const [isRendered, setIsRendered] = useState(false)
    const [hideChildren, setHideChildren] = useState(false)
    const modalRef = useRef()
    useEffect(() => {
        setTimeout(() => {
            setIsRendered(true)
        }, 500)
    }, [])

    useEffect(() => {
        let timeout

        if (isActive) {
            setHideChildren(true)
        } else {
            timeout = setTimeout(() => {
                setHideChildren(false)
            }, 500)
        }
        return () => {
            clearTimeout(timeout)
        }
    }, [isActive])
    return (
        <div ref={modalRef} className={`fixed  z-[50] w-full h-full duration-500 ${isActive ? "top-0 opacity-100" : "top-[100dvh] opacity-100"} bg-[#F8F8F8]  border-[#7059ef]`} style={{ borderTopWidth: isRendered ? "8px" : "" }} >
            {isRendered && hideChildren &&
                children
            }
        </div>
    )
}

export default LayeredDashboardModal